// extracted by mini-css-extract-plugin
module.exports = {"questionAnswerRow":"ChangeSecurityQuestions_questionAnswerRow__2dsTm","questionCell":"ChangeSecurityQuestions_questionCell__3bIcO"};